export default __webpack_public_path__ + "static/media/avisodeprivacidad.66a7952e.pdf";